import cx from "classnames";

import Carousel from "../common/carousel";
import reactLogo from "../../img/logos/react.png";
import nextjs from "../../img/logos/nextjs.png";
import node from "../../img/logos/node.png";
import tailwind from "../../img/logos/tailwind.png";
import typescript from "../../img/logos/typescript.png";
import docker from "../../img/logos/docker.png";
import postgresql from "../../img/logos/postgresql.svg";
import prisma from "../../img/logos/prisma.svg";
import aws from "../../img/logos/aws.svg";
import graphql from "../../img/logos/graphql.png";
import styles from "./technologies.module.css";

const technologies = [
  { name: "TypeScript", logo: typescript },
  { name: "React", logo: reactLogo },
  { name: "Next.js", logo: nextjs },
  { name: "Node.js", logo: node },
  { name: "PostgreSQL", logo: postgresql },
  { name: "Prisma", logo: prisma },
  { name: "Tailwind", logo: tailwind },
  { name: "AWS", logo: aws },
  { name: "Docker", logo: docker },
  { name: "GraphQL", logo: graphql },
];

const TechSection = () => {
  return (
    <div>
      <Carousel>
        {Array(3)
          .fill(technologies)
          .flat()
          .map(({ name, logo }, i) => (
            <div
              key={`${name}-${i}`}
              className={cx(
                "group h-56 w-48 md:h-80 md:w-72 rounded-2xl bg-header-pattern backdrop-blur-xl shadow-xl shrink-0 border-2 border-gray-200 flex flex-col",
                styles.card
              )}
            >
              <div className="flex-1 flex items-center justify-center p-4">
                <img
                  src={logo}
                  alt={name}
                  className="h-16 md:h-24 object-contain"
                />
              </div>
              <div className="pb-5 text-center">
                <p className="uppercase text-sm md:text-base text-gray-500 font-bold font-title tracking-wide">
                  {name}
                </p>
              </div>
            </div>
          ))}
      </Carousel>
    </div>
  );
};

export default TechSection;
